/*
 *
 * ConfirmReverseTransactionModal
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 30-Jun-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import formattedMessage from './languageModule'
import MerchantModal from '@nexidigital/merchantmodal'
import Toggle from 'Hoc/ToggleComponent'
import { formatCurrency, nullSafe } from 'Utility/globalMethods'
import './ConfirmReverseTransactionModal.scss'
import { useIntl } from 'react-intl'

const ConfirmReverseTransactionModal = (props) => {
  const handleClose = () => {
    props.actions.doHidePopup()
  }
  const intl = useIntl()

  const refundAmount = nullSafe(() => props.amount || props?.refundTransaction?.maxRefundableAmount || props.transactionDetails?.transactionAmount, 0)
  const transactionType = nullSafe(() => props?.refundTransaction?.transactionType || props.selectedTab, null)
  const partiallyRefundable = nullSafe(() => props.partiallyRefundable, false)
  const otpRequired = nullSafe(() => props?.refundTransaction?.otpRequired, null)

  return (
    <Toggle>
      <MerchantModal
        title={formattedMessage.titleModal}
        customAnalyticsDescription={intl.formatMessage({ id: 't.app.transactions.transactionDetails.descriptionModal' }, { amountReversed: formatCurrency(refundAmount) })}
        description={
          <div className='trasactionRefundAmount'>
            <MerchantGenericCard
              title={formattedMessage.descriptionModal(formatCurrency(refundAmount))}
              subtitle={formattedMessage.subTitleModal}
            />
          </div>
        }
        onClose={handleClose}
        primaryButtonLabel={formattedMessage.labelPrimaryButtonModal}
        primaryButtonLoading={props.isLoading}
        primaryAction={() => {
          props.actions.doTransactionRefund({
            transactionDetailsSearch: {
              transactionId: props.transactionTabDetails.overview.transactionDetails.transactionId,
              authorizationCode: props.transactionTabDetails.overview.transactionDetails.authorizationCode,
              serviceType: props.transactionTabDetails.overview.transactionDetails.serviceType,
              terminalCode: props.transactionTabDetails.overview.transactionShopDetails.terminalCode,
              transactionDateTime: props.transactionTabDetails.overview.transactionDetails.transactionDateTime,
              status: props.transactionTabDetails.overview.transactionDetails.status,
              shopName: props.transactionTabDetails.overview.transactionShopDetails.shopName,
              paymentMethod: props.transactionTabDetails.overview.transactionDetails.paymentMethod,
              cardCountry: props.transactionTabDetails.overview.transactionDetails.cardCountry
            },
            refundAmount,
            partiallyRefundable, // Useful for Frontend and not for Backend
            otpRequired, // Useful for Frontend and not for Backend
            transactionType // Useful for Frontend and not for Backend
          })
        }}
        secondaryButtonLabel={formattedMessage.labelSecondaryButtonModal}
        secondaryAction={handleClose}
      />
    </Toggle>
  )
}

ConfirmReverseTransactionModal.propTypes = {
  actions: PropTypes.object,
  isLoading: PropTypes.bool,
  amount: PropTypes.string,
  refundTransaction: PropTypes.object,
  partiallyRefundable: PropTypes.bool,
  selectedTab: PropTypes.string,
  transactionDetails: PropTypes.object,
  transactionTabDetails: PropTypes.object
}

ConfirmReverseTransactionModal.defaultProps = {
  actions: {},
  isLoading: false,
  amount: '',
  refundTransaction: {},
  partiallyRefundable: false,
  selectedTab: null,
  transactionDetails: {},
  transactionTabDetails: {}
}

export default ConfirmReverseTransactionModal
